import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import Spinner from '../Spinner/Spinner.js';
import styles from './ButtonGroup.module.scss.js';

var ButtonGroup = (function (_super) {
    __extends(ButtonGroup, _super);
    function ButtonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonGroup.prototype.render = function () {
        var isLoading = !!this.props.isLoading;
        return (React.createElement("div", { className: classNames(styles.group, styles[this.props.textAlign || ''], this.props.className) }, isLoading ? (React.createElement("div", { className: styles.wrapper },
            React.createElement("div", { className: styles.spinner },
                React.createElement(Spinner, { label: this.props.spinnerLabel })))) : (React.createElement("div", { className: styles.wrapper }, React.Children.map(this.props.children, function (item, index) {
            return (React.createElement("div", { key: "ButtonGroup_" + index, className: styles.button }, item));
        })))));
    };
    return ButtonGroup;
}(React.PureComponent));

export { ButtonGroup as default };
//# sourceMappingURL=ButtonGroup.js.map
